export const CREATE_NEW_CATEGORY = 'CREATE_NEW_CATEGORY'